module.exports = __webpack_public_path__ + "static/media/YF49_4.fe050f50.jpg";